/* eslint-disable consistent-return */
import { Middleware, NuxtError } from '@nuxt/types';

const routeAuth: Middleware = async ({ route, store, error }) => {
  try {
    await store.dispatch('szukaj/czyJestRoute', route.path);
  } catch (e) {
    const err = e as NuxtError;

    return error({ statusCode: err.statusCode });
  }
  // routeInfo - model {
  //     Breadcrumbs: null,
  //     Filtr: {
  //       AtrybutyMulti: {
  //         // Lokalizacje_HoteloProdukt: ['francja', 'hiszpania'],
  //         //  Miasta: ["KTW", "POZ", "bialystok"],
  //         //    Promocja: ['single-nie-placa', 'happy-hours'],
  //         Wyzywienie: ['2-posilki']
  //       },
  //       AtrybutySingle: {
  // eslint-disable-next-line no-irregular-whitespace
  //         // DlugoscPobytu: ["*-*", "5-5"], //+ //AtrybutySingle -> DlugoscPobytu to start with a custom value pattern -> ["*​​-*", "5-5"]
  //         Cena: ['5-686'], //+
  //         OcenaKlientow: ["0-5"], //+
  //       }
  //      },
  // }
};
export default routeAuth;
